const staging_config = {
  serverUrl: 'https://api-video-staging.myinterview.com',
  INTERCOM_APP_ID: 'pzs0slby',
  SENTRY_DSN: 'https://a49d1d55605640f4890f9534766f0ea8@o79324.ingest.sentry.io/6579209',
};

export default staging_config;
